(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellani-bundle"] && !Shopify.designMode) return;
  try {
    
  class BellaniBundle extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-bundle-add]');
      this.note = this.querySelector('[data-bundle-note]');
      this.label = this.querySelector('[data-bundle-label]');
      if (!this.btn) return;
      this.initialLabel = this.label ? this.label.textContent : '';
      this.btn.addEventListener('click', () => this.add());
    }

    async add() {
      const ids = [this.dataset.sofa, this.dataset.pouf].filter(Boolean);
      if (ids.length < 2) return;

      this.btn.disabled = true;
      if (this.label) this.label.textContent = 'Ajout en cours…';
      this.note.textContent = '';

      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) }),
        });

        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'Ajout impossible');
        }

        if (this.label) this.label.textContent = 'Ajouté au panier';
        this.note.textContent = 'Les deux pièces sont dans votre panier.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        this.refreshCart();

        setTimeout(() => {
          this.btn.disabled = false;
          if (this.label) this.label.textContent = this.initialLabel;
        }, 2600);
      } catch (e) {
        console.error('[bellani-bundle]', e);
        this.note.textContent = "L'ajout a échoué. Rechargez la page et réessayez.";
        this.btn.disabled = false;
        if (this.label) this.label.textContent = this.initialLabel;
      }
    }

    // Shrine expose plusieurs conteneurs de panier selon le réglage du thème :
    // on rafraîchit celui qui est présent, sans présumer lequel.
    refreshCart() {
      const drawer = document.querySelector('cart-drawer');
      const notif = document.querySelector('cart-notification');
      if (drawer && typeof drawer.renderContents === 'function') {
        fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('cart-drawer');
            if (fresh) {
              drawer.innerHTML = fresh.innerHTML;
              if (typeof drawer.open === 'function') drawer.open();
            }
          })
          .catch(() => window.location.assign(`${window.Shopify.routes.root}cart`));
      } else if (!notif) {
        window.location.assign(`${window.Shopify.routes.root}cart`);
      }
    }
  }

  if (!customElements.get('bellani-bundle')) {
    customElements.define('bellani-bundle', BellaniBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellani-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellani-look')) {
    class BellaniLook extends HTMLElement {
      connectedCallback() {
        this.dots = Array.from(this.querySelectorAll('.blk-dot'));
        this.items = Array.from(this.querySelectorAll('.blk-item'));
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            this.activate(index);
            const item = this.items[index];
            if (item && window.matchMedia('(max-width: 989px)').matches) {
              item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          });
          dot.addEventListener('mouseenter', () => this.activate(index));
        });
        this.items.forEach((item, index) => {
          item.addEventListener('mouseenter', () => this.activate(index));
          item.addEventListener('focusin', () => this.activate(index));
        });
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.items.indexOf(event.target.closest('.blk-item'));
          if (index > -1) this.activate(index);
        });
        this.activate(0);
      }

      activate(index) {
        this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i === index));
        this.items.forEach((item, i) => item.classList.toggle('is-on', i === index));
      }
    }
    customElements.define('bellani-look', BellaniLook);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bellani-nuancier"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bellani-nuancier')) {
    class BellaniNuancier extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.bn-panel'));
        this.bar = this.querySelector('.bn-tabs-bar');
        this.token = 0;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index, false));
          tab.addEventListener('keydown', (event) => this.onTabKey(event, index));
        });

        this.panels.forEach((panel) => {
          this.swatchesOf(panel).forEach((swatch, index) => {
            swatch.addEventListener('click', () => this.selectSwatch(panel, index, false));
            swatch.addEventListener('keydown', (event) => this.onSwatchKey(event, panel, index));
          });
        });

        this.onBlockSelect = (event) => {
          const swatch = event.target.closest('.bn-swatch');
          if (!swatch) return;
          const panel = swatch.closest('.bn-panel');
          const panelIndex = this.panels.indexOf(panel);
          if (panelIndex > -1 && this.tabs.length) this.selectTab(panelIndex, false);
          this.selectSwatch(panel, this.swatchesOf(panel).indexOf(swatch), false);
        };
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.moveBar();
        const tablist = this.querySelector('.bn-tabs');
        if (tablist && 'ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.moveBar());
          this.resizeObserver.observe(tablist);
        }
        if (document.fonts) document.fonts.ready.then(() => this.moveBar());
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      swatchesOf(panel) {
        return Array.from(panel.querySelectorAll('.bn-swatch'));
      }

      moveBar() {
        if (!this.bar) return;
        const active = this.tabs.find((tab) => tab.classList.contains('is-on'));
        if (!active) return;
        this.bar.style.setProperty('--bn-bar-x', `${active.offsetLeft}px`);
        this.bar.style.setProperty('--bn-bar-w', `${active.offsetWidth}px`);
      }

      selectTab(index, focus) {
        if (!this.tabs[index]) return;
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.classList.toggle('is-on', on);
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          const on = i === index;
          panel.classList.toggle('is-on', on);
          panel.inert = !on;
        });
        this.moveBar();
        if (focus) this.tabs[index].focus();
      }

      onTabKey(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.selectTab(next, true);
      }

      onSwatchKey(event, panel, index) {
        const last = this.swatchesOf(panel).length - 1;
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.selectSwatch(panel, next, true);
      }

      selectSwatch(panel, index, focus) {
        const swatches = this.swatchesOf(panel);
        const swatch = swatches[index];
        if (!swatch) return;

        swatches.forEach((item, i) => {
          const on = i === index;
          item.classList.toggle('is-on', on);
          item.setAttribute('aria-checked', String(on));
          item.tabIndex = on ? 0 : -1;
        });
        if (focus) swatch.focus();

        const id = swatch.dataset.blockId;
        if (panel.dataset.current === id) return;
        panel.dataset.current = id;

        this.swapVisual(panel, id);
        this.swapText(panel, swatch);
      }

      swapVisual(panel, id) {
        const layers = panel.querySelectorAll('[data-layer]');
        const current = layers[0].classList.contains('is-on') ? layers[0] : layers[1];
        const next = current === layers[0] ? layers[1] : layers[0];
        const template = panel.querySelector(`template[data-for="${id}"]`);
        if (!template) return;

        const token = ++this.token;
        next.replaceChildren(template.content.cloneNode(true));
        const reveal = () => {
          if (token !== this.token) return;
          next.classList.add('is-on');
          current.classList.remove('is-on');
        };
        const image = next.querySelector('img');
        if (image && !image.complete) {
          image.addEventListener('load', reveal, { once: true });
          image.addEventListener('error', reveal, { once: true });
        } else {
          reveal();
        }
      }

      swapText(panel, swatch) {
        const name = panel.querySelector('.bn-name');
        const phrase = panel.querySelector('.bn-phrase');
        const cta = panel.querySelector('.bn-cta');
        const soon = panel.querySelector('.bn-soon');

        name.textContent = swatch.dataset.name;
        phrase.textContent = swatch.dataset.phrase;
        phrase.hidden = !swatch.dataset.phrase;

        if (swatch.dataset.url) {
          cta.href = swatch.dataset.url;
          cta.textContent = swatch.dataset.cta;
          cta.hidden = false;
          soon.hidden = true;
        } else {
          cta.hidden = true;
          soon.hidden = false;
        }

        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          [name, phrase].forEach((el) => {
            el.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'ease-out' });
          });
        }
      }
    }

    customElements.define('bellani-nuancier', BellaniNuancier);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
